import { ApiError } from './apiError.js';

export class DataLoadError extends Error {
	constructor(public readonly failures: ApiError[]) {
		super(failures.map(error => error.message).join('; '));
		this.name = 'DataLoadError';
	}
}
